module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"view":"View this map","organizations":"organizations","domains":"domain names"},"nl":{"view":"Bekijk deze kaart","organizations":"organisaties","domains":"domeinen"}}')
  delete Component.options._Ctor
}
